






import { defineComponent, computed, useRouter } from "@nuxtjs/composition-api";
import { usePageStore } from "~/stores/page";

import CATEGORY from "~/modules/catalog/pages/category.vue";
import CMS_PAGE from "~/pages/Cms.vue";
import PRODUCT from "~/modules/catalog/pages/product.vue";
import { useUiHelpers } from "~/composables";
import { isFilterEnabled } from "~/modules/catalog/category/config/FiltersConfig";
import _ from "lodash";
export default defineComponent({
  name: "PageResolver",
  components: {
    CATEGORY,
    CMS_PAGE,
    PRODUCT,
  },
  middleware: ["url-resolver"],
  setup() {
    const { routeData } = usePageStore();
    const uiHelpers = useUiHelpers();
    const filters = uiHelpers.getFacetsFromURL().filters;
    const router = useRouter();
    const checkfilter = _.isEmpty(uiHelpers.getFacetsFromURL().filters)
      ? true
      : !Object.keys(filters).some(key => !isFilterEnabled(key))
      // : Object.keys(filters).find((key) => {
      //     if (!isFilterEnabled(key)) return isFilterEnabled(key);
      //   }) === undefined
      // ? false
      // : true;    
    const type = computed(() => routeData?.type);
    if (!checkfilter) {
      return router.push("/error.html");
    }
    return {
      type,
    };
  },
});
